import ManagerAccommodationAccount from './ManagerAccommodationAccount.container';

export default ManagerAccommodationAccount;
